var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGps = function SvgGps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gps_svg__a",
    width: 14,
    height: 14,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h14v14H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gps_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M7 12.513a.29.29 0 0 1-.211-.08.29.29 0 0 1-.08-.211v-.555q-1.823-.174-3.011-1.363-1.189-1.188-1.364-3.012H1.78a.27.27 0 0 1-.211-.087.3.3 0 0 1-.08-.204q0-.131.08-.212a.28.28 0 0 1 .21-.08h.555q.175-1.823 1.364-3.012Q4.886 2.51 6.709 2.334V1.78q0-.131.088-.212A.3.3 0 0 1 7 1.488q.13 0 .212.08.08.08.08.212v.554q1.823.175 3.011 1.363 1.188 1.19 1.363 3.012h.555q.131 0 .21.088.081.087.081.204a.29.29 0 0 1-.08.212.29.29 0 0 1-.211.08h-.555q-.174 1.823-1.363 3.011-1.188 1.188-3.012 1.363v.555q0 .131-.087.21a.3.3 0 0 1-.204.081m0-1.429q1.693 0 2.888-1.196 1.196-1.196 1.196-2.887T9.888 4.113 7.001 2.917 4.113 4.113 2.917 7.001q.001 1.692 1.196 2.887t2.888 1.196m0-2.333q-.728 0-1.239-.51-.51-.51-.51-1.24t.51-1.24 1.24-.51q.73 0 1.24.51t.51 1.24-.51 1.24q-.51.51-1.24.51m0-.584q.482 0 .825-.343.342-.342.342-.823 0-.482-.342-.824a1.13 1.13 0 0 0-.824-.343q-.482 0-.824.343A1.12 1.12 0 0 0 5.834 7q0 .48.343.823.342.344.824.343"
  }))));
};
export default SvgGps;